import React, { useState, useMemo } from "react";

import Tooltip from "@mui/material/Tooltip";
import Checkbox from "@mui/material/Checkbox";
import ReplyIcon from '@mui/icons-material/Reply';
import { Box, TextField, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import './CustomerDashboard.css'; 

import IconButton from "@mui/material/IconButton";
import SendIcon from '@mui/icons-material/Send';
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import RefreshIcon from "@mui/icons-material/Refresh";
import CloseIcon from "@mui/icons-material/Close";
import ChecklistRtlIcon from "@mui/icons-material/ChecklistRtl";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function CustomerDashboard({ type }) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [editCustomer, setEditCustomer] = useState(null);


  const theme = useTheme();

  const customers = [
  { id: 1, companyName: "VisionTech Solutions", imageUrl: "images/conct2.png", registeredDate: "2025-05-12" },
  { id: 2, companyName: "Kamal Enterprises", imageUrl: "images/conct1.png", registeredDate: "2025-05-13" },
  { id: 3, companyName: "Nimal Holdings", imageUrl: "images/conct2.png", registeredDate: "2025-05-14" },
  { id: 4, companyName: "Sachini Technologies", imageUrl: "images/conct3.png", registeredDate: "2025-05-15" },
  { id: 5, companyName: "Dilan Solutions", imageUrl: "src/Assets/conct4.png", registeredDate: "2025-05-16" },
  { id: 6, companyName: "VisionTech Solutions", imageUrl: "images/conct2.png", registeredDate: "2025-05-12" },
  { id: 7, companyName: "VisionTech Solutions", imageUrl: "images/conct2.png", registeredDate: "2025-05-12" },
  { id: 8, companyName: "VisionTech Solutions", imageUrl: "images/conct2.png", registeredDate: "2025-05-12" },
  { id: 9, companyName: "VisionTech Solutions", imageUrl: "images/conct2.png", registeredDate: "2025-05-12" }
];


  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditCustomer(null);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formJson = Object.fromEntries(formData.entries());
    const email = formJson.email;
    console.log(email);
    handleClose();
  };

  const editSelectedCustomer = (e, customer) => {
    e.stopPropagation();          // prevents card click
    setEditCustomer(customer);    // store selected customer
    setOpen(true);   
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id]
    );
  };

  const selectAllCustomers = () =>{
    const allSelected = customers.every(c => selectedIds.includes(c.id));

    if (allSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(customers.map(c => c.id));
    }
  };

  return (
    <div style={{ height: "80vh", display: "flex" }}>
      <div style={{ flex: 2, borderRight: "1px solid #ddd" }}>
        <div style={{ padding: "12px 16px", borderBottom: "1px solid #ddd", display: "flex", justifyContent: "space-between" }}>
          <div>
            <h4 style={{ fontWeight: "Bold", paddingBottom: 0, marginBottom: 0, paddingTop: "8px", color:"#0098f0ff"  }}>
              Customers
            </h4>
          </div>

          <div>
            <Tooltip title="Refresh">
              <IconButton
                sx={{
                  // color: "rgba(0, 0, 0, 0.7)",
                  "&:hover": {
                    color: "#2091e7ff",
                    backgroundColor: "transparent",
                  },
                }}
              > <RefreshIcon /></IconButton>
            </Tooltip>
            <Tooltip title="Select All">
              <IconButton
                sx={{
                  // color: "rgba(0, 0, 0, 0.7)",
                  "&:hover": {
                    color: "#2091e7ff",
                    backgroundColor: "transparent",
                  },
                }}
              onClick={() => selectAllCustomers()}
              > <ChecklistRtlIcon /></IconButton>
            </Tooltip>
            
            <Tooltip title="Delete">
              <IconButton
                sx={{
                  // color: "rgba(0, 0, 0, 0.7)",
                  "&:hover": {
                    color: "red",
                    backgroundColor: "transparent",
                  },
                }}
              > <DeleteForeverIcon /></IconButton>
            </Tooltip>
          </div>
        </div>
        <div style={{
          padding: 10, borderRadius: 8, display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",  gridAutoRows: "1fr",    textAlign: "center", gap:15
        }}>
          {customers.map(item => (
            <div
              key={item.id}
              style={{
                position: "relative",
                margin: "5px",
                padding: 12,
                cursor: "pointer",
                border: "1px solid #ddd",
                borderRadius: 8,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
                
              }}
              className="customer-card"
            >
              <img src={item.imageUrl}
                alt={item.companyName} width={100} height={100}
                style={{ border: "1px solid black", objectFit: "cover", borderRadius: 8 }} />
              <div style={{ paddingTop: 8 }}>
                <div><strong> {item.companyName}</strong></div>
                <div style={{ fontSize: "12px" }}>{item.registeredDate}</div>
              </div>
              
              <div className="card-actions">
                <Checkbox
                  sx={{
                    "&:hover": {
                      background: "transparent"
                    }
                  }}
                  size="small"
                  checked={selectedIds.includes(item.id)}
                  onClick={e => e.stopPropagation()} // prevent card click
                  onChange={() => handleCheckboxChange(item.id)}
                  title="Select"
                />

                <div className="hover-actions">
                  <IconButton
                    size="small"
                    sx={{
                      "&:hover": {
                        color: "#2091e7ff",
                        backgroundColor: "transparent"
                      },
                    }}
                    onClick={(e) => editSelectedCustomer(e, item)}
                    title="Edit"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>

                  <IconButton
                    size="small"
                    sx={{
                      "&:hover": {
                        color: "red",
                        backgroundColor: "transparent"
                      },
                    }}
                    onClick={(e) => e.stopPropagation()}
                    title="Delete"
                  >
                    <DeleteForeverIcon />
                  </IconButton>
                </div>
              </div>

            </div>
            
            
          ))}

          {/* Add New Customer */}
          <div
            key={1000}
            onClick={handleClickOpen}
            style={{
              margin: "5px",
              padding: 12,
              cursor: "pointer",
              border: "1px solid #ddd",
              borderRadius: 8,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
            }}
          >
            <AddIcon fontSize="large" />
            <div style={{ paddingTop: 8 }}>
              <div><strong> Add a New Customer </strong></div>
            </div>
          </div>      
        </div>
      </div>

      <Dialog open={open}  onClose={handleClose}>
        <DialogTitle align="center" fontWeight="bold">Add a New Customer </DialogTitle>
        <DialogContent>
          <form onSubmit={handleSubmit} id="add-customer-form">
            <TextField
              autoFocus
              required
              margin="dense"
              id="company-name"
              label="Company"
              variant="outlined"
              fullWidth
              value={editCustomer?.companyName || ""}
                onChange={(e) =>
                  setEditCustomer({
                    ...editCustomer,
                    companyName: e.target.value,
                  })
                }
            />
            <TextField
              autoFocus
              required
              margin="dense"
              id="registred-date"
              label="Registered Date"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={editCustomer?.registeredDate || ""}
                onChange={(e) =>
                  setEditCustomer({
                    ...editCustomer,
                    registeredDate: e.target.value,
                  })
                }

            />
            <TextField
              autoFocus
              required
              margin="dense"
              id="registred-date"
              label="Birthday"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={editCustomer?.registeredDate || ""}
                onChange={(e) =>
                  setEditCustomer({
                    ...editCustomer,
                    registeredDate: e.target.value,
                  })
                }
            />
                        <TextField
              autoFocus
              required
              margin="dense"
              id="email"
              label="Email"
              type="email"
              variant="outlined"
              fullWidth
              value={editCustomer?.email || ""}
              onChange={(e) =>
                setEditCustomer({
                  ...editCustomer,
                  email: e.target.value,
                })
              }
            />

            <TextField
              autoFocus
              required
              margin="dense"
              id="company-logo"
              label="Company Logo"
              type="file"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              
            />
            
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" form="add-customer-form">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </div>

    
  );
}
